import { render, staticRenderFns } from "./EmployeeAnnouncementDetails.vue?vue&type=template&id=54802dc4&scoped=true"
import script from "./EmployeeAnnouncementDetails.vue?vue&type=script&lang=js"
export * from "./EmployeeAnnouncementDetails.vue?vue&type=script&lang=js"
import style0 from "./EmployeeAnnouncementDetails.vue?vue&type=style&index=0&id=54802dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54802dc4",
  null
  
)

export default component.exports